import { useQuery } from "@tanstack/vue-query";
import { explorerApi } from "~/api/client";
import type { NexonLwScheduledSupplyInfo } from "~/api/repository/models/NexonLwScheduledSupplyInfo";

export const getLivewatchScheduleSupplyDonut = ({ date }: { date: Ref<number> }) => {
    return useQuery({
        queryKey: ['livewatchScheduleSupplyDonut', date],
        queryFn: () => explorerApi.lwController.getScheduledSupplyDonut({
            requestBody: {
                timestamp: date.value / 1000
            }
        }).then(res => livewatchScheduleSupplyDonutDto(res))
    })
}

export type LivewatchScheduleSupplyDonut = {
    timestamp: number;
    list: Array<LivewatchScheduleSupplyCategoryPercent>;
}

export type LivewatchScheduleSupplyCategoryPercent = {
    name: string;
    y: number;
    percent: string;
}

export const livewatchScheduleSupplyDonutDto = (data: NexonLwScheduledSupplyInfo): LivewatchScheduleSupplyDonut => {
    return {
        timestamp: data.TS * 1000,
        list: data.CTLIST.map(item => ({
            name: item.NM,
            y: Number(item.SS),
            percent: item.PER,
        })),
    }
}